import { Box, Typography } from "@mui/material";
import { Dayjs } from "dayjs";
import { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import { T } from "react-translator-component";
import DateSelectDialog from "./DateSelectDialog";

export interface TermRef {
  getTerm: () => { startDate: Dayjs; endDate: Dayjs}
  validate: () => boolean
}

interface Props {
  baseDate: Dayjs
  initStartDate?: Dayjs
  initEndDate?: Dayjs
  isSelectDateLimit?: boolean
  disabled?: boolean
  vertical?: boolean
  children?: React.ReactElement
}

const Term = forwardRef<TermRef, Props>((
  {
    baseDate,
    initStartDate = undefined,
    initEndDate = undefined,
    isSelectDateLimit = true,
    disabled,
    vertical,
    children
  }, ref) =>
{
  // 公開処理
  useImperativeHandle(ref, () => ({
    getTerm: () => {
      return {
        startDate: startDate,
        endDate: endDate
      }
    },
    validate: () => isValidTerm()
  }));

  // 内部処理

  const [startDate, setStartDate] = useState<Dayjs>(initStartDate ?? baseDate);
  const [endDate, setEndDate] = useState<Dayjs>(initEndDate ?? baseDate);
  const [errors, setErrors] = useState<{[key: string]: string}>({
    endDate: ''
  });

  const changeStartDate = (date: Dayjs) => {
    setStartDate(date);
    setErrors({ ...errors, endDate: ''});
  }

  const changeEndDate = (date: Dayjs) => {
    setEndDate(date);
    setErrors({ ...errors, endDate: ''});
  }

  const isValidTerm = () => {
    const end = endDate.startOf('day');
    const start = startDate.startOf('day');
    if (end.isAfter(start) || end.isSame(start)) {
      return true
    }
    setErrors({ ...errors, endDate: T('mng_error_invalid_end_date')});
    return false;
  }

  useEffect(() => {
    if (!startDate) return
    startDate?.isAfter(endDate) && changeEndDate(startDate)
  }, [startDate])

  return (
    <Box sx={vertical ? {} : { display: "flex"}}>
      <Box sx={vertical ? {} : styles.termContainerHolizontal }>
        <DateSelectDialog
          disabled={disabled}
          inputedDate={startDate}
          maxDate={isSelectDateLimit ? baseDate : undefined}
          onChange={changeStartDate}
        />
        <Typography sx={vertical ? styles.termSeparatorVertical : styles.termSeparatorHolizontal}>{T('mng_term_separator')}</Typography>
        <DateSelectDialog
          disabled={disabled}
          inputedDate={endDate}
          maxDate={isSelectDateLimit ? baseDate : undefined}
          minDate={startDate}
          errorMessage={errors.endDate}
          onChange={changeEndDate}
        />
      </Box>
    </Box>
  );
});
export default Term;

const styles = {
  termContainerHolizontal: {
    display: "flex",
    alignItems: "start",
    gap: 1
  },
  termSeparatorHolizontal: {
    paddingTop: "1.5em"
  },
  termSeparatorVertical: {
    paddingY: 1,
    paddingLeft: 2,
    writingMode: "vertical-rl"
  }
}
